export default __webpack_public_path__ + "static/media/stock2_fhd.f63583f8.jpg";